// extracted by mini-css-extract-plugin
export default {"footer":"KC4tw4cgUdtKb7OpfijP"};